import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import * as fonts from '@helpcenter/styles/src/fonts';
import { ThemedLink } from '@helpcenter/themed-link';
import type { WrappedComponentProps } from 'react-intl-next';
import { injectIntl, FormattedMessage } from 'react-intl-next';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import messages from './messages';

interface Props {
    isError: boolean;
}

export const AnonymousEmailSignupMessage = ({ isError, intl }: Props & WrappedComponentProps) => {
    return (
        <Wrapper>
            {isError ? (
                <ErrorIcon
                    size={'small'}
                    label="error"
                    primaryColor={token('color.icon.danger', colors.R300)}
                    secondaryColor={token('color.icon.inverse', colors.N0)}
                />
            ) : (
                <WarningIcon size={'small'} label="warning" primaryColor={token('color.icon.warning', colors.Y300)} />
            )}

            <SignupMessage isError={isError}>
                <FormattedMessage
                    {...messages.signupWarningMessage}
                    values={{
                        signUpLink: (
                            <ThemedLink to={'/user/login'} target="_blank" actionSubjectId="signupLink">
                                {intl.formatMessage(messages.signupLink)}
                            </ThemedLink>
                        ),
                    }}
                />
            </SignupMessage>
        </Wrapper>
    );
};

export default injectIntl(AnonymousEmailSignupMessage);

const requestCreateFieldErrorColor = token('color.text.danger', colors.R500);
const anonymousEmailSignupWarningTextColor = token('color.text.subtlest', colors.N200);
interface SignupMessageProps {
    isError?: boolean;
}

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const SignupMessage = styled.span<SignupMessageProps>`
    ${fonts.xsmall};
    color: ${(props) => (props.isError ? requestCreateFieldErrorColor : anonymousEmailSignupWarningTextColor)};
    font-weight: 500;
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Wrapper = styled.div`
    display: flex;
    margin-top: ${token('space.050', '4px')};
`;
